import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clinicdx',
  templateUrl: './clinicdx.component.html',
  styleUrls: ['./clinicdx.component.css']
})
export class ClinicdxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
